// extracted by mini-css-extract-plugin
export default {"contactSection":"Contact_contactSection__N141V","contactButton":"Contact_contactButton__lxvB+","contactDescription":"Contact_contactDescription__q7-Ya"};